// CREATE ORDER
export const CREATE_ORDER_REQUEST = "ORDER.CREATE_ORDER_REQUEST";
export const CREATE_ORDER_SUCCESS = "ORDER.CREATE_ORDER_SUCCESS";
export const CREATE_ORDER_FAILURE = "ORDER.CREATE_ORDER_FAILURE";

// GET ALL ORDER
export const GET_LIST_REQUEST = "ORDER.GET_LIST_REQUEST";
export const GET_LIST_SUCCESS = "ORDER.GET_LIST_SUCCESS";
export const GET_LIST_FAILURE = "ORDER.GET_LIST_FAILURE";

// GET USER'S ORDER
export const GET_USER_REQUEST = "ORDER.GET_USER_REQUEST";
export const GET_USER_SUCCESS = "ORDER.GET_USER_SUCCESS";
export const GET_USER_FAILURE = "ORDER.GET_USER_FAILURE";

// GET SINGLE ORDER
export const GET_SINGLE_REQUEST = "ORDER.GET_SINGLE_REQUEST";
export const GET_SINGLE_SUCCESS = "ORDER.GET_SINGLE_SUCCESS";
export const GET_SINGLE_FAILURE = "ORDER.GET_SINGLE_FAILURE";

// EDIT SINGLE ORDER
export const EDIT_SINGLE_REQUEST = "ORDER.EDIT_SINGLE_REQUEST";
export const EDIT_SINGLE_SUCCESS = "ORDER.EDIT_SINGLE_SUCCESS";
export const EDIT_SINGLE_FAILURE = "ORDER.EDIT_SINGLE_FAILURE";

// DELETE SINGLE ORDER
export const DELETE_SINGLE_REQUEST = "ORDER.DELETE_SINGLE_REQUEST";
export const DELETE_SINGLE_SUCCESS = "ORDER.DELETE_SINGLE_SUCCESS";
export const DELETE_SINGLE_FAILURE = "ORDER.DELETE_SINGLE_FAILURE";
